import { render, staticRenderFns } from "./PlanEstudio.vue?vue&type=template&id=6edf431c&"
import script from "./PlanEstudio.vue?vue&type=script&lang=js&"
export * from "./PlanEstudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports